import { serializeChildren } from '#pplx/frontend/composer-sdk/internal/serialization/serializeChildren.js';
/**
 * Projects saved editor state to trimmed text, retaining link and mention syntax.
 * Quote and code formatting is omitted; paragraphs are separated by a newline.
 *
 * @param state - Serialized Composer value to project without creating a live editor.
 */
export function serializedStateToPlainText(state) {
    return serializeChildren({ children: state.root.children, separator: '\n' }).trim();
}
//# sourceMappingURL=serializedStateToPlainText.js.map